import React from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import LoaderSuspense from "../components/common/LoaderSuspense";
import { useGetCatalogVendeurQuery } from "../utils/api/catalog/catalog.api";

/** Redirige les anciennes URLs /b/:slug vers /catalogue/:catalog_slug */
export default function CatalogLegacyRedirect() {
  const { shopSlug } = useParams<{ shopSlug: string }>();
  const location = useLocation();
  const slug = shopSlug?.trim() ?? "";

  const { data, isLoading, isError } = useGetCatalogVendeurQuery(slug, {
    skip: !slug,
  });

  if (!slug) {
    return <Navigate to="/site-non-disponible" replace />;
  }

  if (isLoading) {
    return <LoaderSuspense />;
  }

  if (isError || !data?.catalog_slug) {
    return <Navigate to="/site-non-disponible" replace />;
  }

  const suffix = location.pathname.replace(/^\/b\/[^/]+/, "") || "";
  const target = `/catalogue/${data.catalog_slug}${suffix}${location.search}`;

  return <Navigate to={target} replace />;
}
